/* Aurora localization drawer — clean dropdown UX.
   Country + language are dropdowns: toggle opens the list, picking sets the hidden
   input + updates the toggle, and a click anywhere in the drawer (outside an open
   dropdown) closes it. Continue submits the one localization form.
   Panel + overlay are relocated to <body> so they render as a true full-viewport
   overlay (the mobile menu's transform/overflow would otherwise trap/clip them). */
(function () {
  class AuroraLocalization extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-aurora-loc-open]');
      this.overlayEl = this.querySelector('.aurora-loc__overlay');
      this.panel = this.querySelector('.aurora-loc__drawer');
      if (!this.panel || this.dataset.ready) return;
      this.dataset.ready = '1';

      document.body.appendChild(this.overlayEl);
      document.body.appendChild(this.panel);

      this.countryInput = this.panel.querySelector('[data-loc-country-input]');
      this.langInput = this.panel.querySelector('[data-loc-lang-input]');
      this.search = this.panel.querySelector('[data-loc-search]');
      this.fields = this.panel.querySelectorAll('[data-loc-dd]');
      this._esc = this._esc.bind(this);

      var self = this;
      if (this.trigger) this.trigger.addEventListener('click', this.open.bind(this));
      [this.overlayEl, this.panel].forEach(function (root) {
        if (root.hasAttribute('data-aurora-loc-close')) root.addEventListener('click', self.close.bind(self));
        root.querySelectorAll('[data-aurora-loc-close]').forEach(function (b) {
          b.addEventListener('click', self.close.bind(self));
        });
      });

      this.panel.querySelectorAll('[data-loc-dd-toggle]').forEach(function (t) {
        t.addEventListener('click', function (e) { e.stopPropagation(); self.toggleDropdown(t); });
      });
      this.panel.querySelectorAll('[data-loc-country]').forEach(function (b) {
        b.addEventListener('click', function () { self.pickCountry(b); });
      });
      this.panel.querySelectorAll('[data-loc-lang]').forEach(function (b) {
        b.addEventListener('click', function () { self.pickLang(b); });
      });
      if (this.search) this.search.addEventListener('input', function () { self.filter(); });

      // click anywhere in the drawer that isn't an open dropdown or a toggle → close dropdowns
      this.panel.addEventListener('click', function (e) {
        if (!e.target.closest('[data-loc-dd-panel]') && !e.target.closest('[data-loc-dd-toggle]')) {
          self.closeDropdowns();
        }
      });

      var details = this.closest('details');
      if (details) details.addEventListener('toggle', function () { if (details.open) self.close(); });
    }

    _esc(e) {
      if (e.key !== 'Escape') return;
      if (this.hasOpenDropdown()) this.closeDropdowns();
      else this.close();
    }

    hasOpenDropdown() {
      return !!this.panel.querySelector('[data-loc-dd-panel]:not([hidden])');
    }

    closeDropdowns() {
      this.fields.forEach(function (f) {
        var p = f.querySelector('[data-loc-dd-panel]');
        var t = f.querySelector('[data-loc-dd-toggle]');
        if (p) p.setAttribute('hidden', '');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    toggleDropdown(toggle) {
      var field = toggle.closest('[data-loc-dd]');
      var panel = field.querySelector('[data-loc-dd-panel]');
      var wasOpen = !panel.hasAttribute('hidden');
      this.closeDropdowns();
      if (!wasOpen) {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      }
    }

    pickCountry(btn) {
      if (this.countryInput) this.countryInput.value = btn.getAttribute('data-loc-country');
      var field = btn.closest('[data-loc-dd]');
      var current = field.querySelector('[data-loc-current]');
      if (current) {
        var optFlag = btn.querySelector('.aurora-flag');
        var curFlag = current.querySelector('.aurora-flag');
        if (optFlag && curFlag) curFlag.replaceWith(optFlag.cloneNode(true));
        var nameEl = current.querySelector('[data-loc-current-name]');
        var curEl = current.querySelector('[data-loc-current-cur]');
        if (nameEl) nameEl.textContent = btn.getAttribute('data-loc-name');
        if (curEl) curEl.textContent = btn.getAttribute('data-loc-cur');
      }
      this.panel.querySelectorAll('[data-loc-country]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      this.closeDropdowns();
    }

    pickLang(btn) {
      if (this.langInput) this.langInput.value = btn.getAttribute('data-loc-lang');
      var field = btn.closest('[data-loc-dd]');
      var current = field.querySelector('[data-loc-current-lang]');
      if (current) current.textContent = btn.getAttribute('data-loc-lang-name');
      this.panel.querySelectorAll('[data-loc-lang]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      this.closeDropdowns();
    }

    filter() {
      var q = this.search.value.trim().toLowerCase();
      this.panel.querySelectorAll('[data-loc-country]').forEach(function (b) {
        var name = (b.getAttribute('data-loc-name') || '').toLowerCase();
        b.parentElement.style.display = name.indexOf(q) > -1 ? '' : 'none';
      });
    }

    open() {
      var details = this.closest('details');
      if (details && details.open) {
        var summary = details.querySelector('summary');
        if (summary) summary.click();
      }
      this.overlayEl.classList.add('is-open');
      this.panel.classList.add('is-open');
      document.body.classList.add('aurora-loc-locked');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this._esc);
    }

    close() {
      this.closeDropdowns();
      this.overlayEl.classList.remove('is-open');
      this.panel.classList.remove('is-open');
      document.body.classList.remove('aurora-loc-locked');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this._esc);
    }
  }

  if (!customElements.get('aurora-localization')) {
    customElements.define('aurora-localization', AuroraLocalization);
  }
})();
